import { Box, ParagraphText, TextAction } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';

const renderParagraph = (chunk: React.ReactNode) => (
  <ParagraphText css={{ color: '$onSurfaceTextSubdued' }}>
    {chunk}
  </ParagraphText>
);

const renderMailToLink = (chunk: React.ReactNode) => (
  <TextAction href={`mailto:${chunk}`}>{chunk}</TextAction>
);

const renderLineBreak = () => <br />;

export const IneligibleUserErrorBody = () => {
  const { formatMessage } = useIntl();

  return (
    <Box css={{ '& > p + p': { marginBlockStart: '$half' } }}>
      {formatMessage(
        { id: 'STR_ERROR_STATE_BODY_INELIGIBLE_ERROR' },
        {
          p: renderParagraph,
          a: renderMailToLink,
          br: renderLineBreak,
        },
      )}
    </Box>
  );
};
